module.exports = __webpack_public_path__ + "img/three-dots.09306ede.svg";